import React, {Component} from 'react';
import ErrorOutline from '@material-ui/icons/ErrorOutline';
import {withStyles} from "@material-ui/core/styles/index";
import ErrorsPagesCss from './css/ErrorsPagesCss';
import {Grid, Typography} from '@material-ui/core';

class Error403 extends Component {
  render() {
    const {classes} = this.props;
    return (
      <Grid
        container
        alignItems='center'
      >
        <Grid item lg={4}>
          <ErrorOutline
            className={classes.errorIcon}
            color='primary'
          />
        </Grid>
        <Grid item lg={8}>
          <Typography
            variant='display1'
          >
            403 Error
          </Typography>
          <Typography
            color='primary'
            variant='headline'
          >
            Accès non autorisé
          </Typography>
        </Grid>
      </Grid>
    );
  }
}

Error403 = withStyles(ErrorsPagesCss)(Error403);

export default Error403
